import React from 'react';
import DashContainer from 'modules/dashboard/_common/DashContainer';
import WaiterPage from 'modules/restaurant/waiter/WaiterPage';

export default function DashRestaurantWaiter() {
    return (
        <DashContainer title='Comandas'>
            <WaiterPage />
        </DashContainer>
    );
}
